export default "__VITE_ASSET__CkffLCWU__"